import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/Table';
import { IAdminTransmissionAct, IBaseAdminTransmissionAct } from 'types/income';
import { exportXlsxConfig, getSorting } from 'utils/general';
import { AdminTransmissionActsFilters } from './admin-transmission-acts.types';

const getFilters = (filters: Partial<AdminTransmissionActsFilters>) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  ...getSorting(filters.sort),
  filter: {
    parentCompanyId: filters.parentCompany,
    companyIds: filters.companies,
    dateFrom: filters.date?.from,
    dateTo: filters.date?.to,
  },
});

interface GetTransmissionActs {
  filters: Partial<AdminTransmissionActsFilters>;
}

interface GetTransmissionAct {
  transmissionActId: string;
}

interface ExportXls {
  transmissionActId: string;
}

interface UpdateTransmissionAct {
  transmissionActId: string;
  data: {
    openingBalance: number;
    closingBalance: number;
  };
}

export const loaders = {
  getTransmissionActs: ({ filters }: GetTransmissionActs) => {
    return api<TableDataResponse<IBaseAdminTransmissionAct>>({
      url: Endpoints.melpAdmin.transmissionActs.root,
      params: getFilters(filters),
    });
  },
  getTransmissionAct: ({ transmissionActId }: GetTransmissionAct) => {
    return api<IAdminTransmissionAct>({
      url: Endpoints.melpAdmin.transmissionActs.byId.root.replace(
        ':transmissionActId',
        transmissionActId,
      ),
    });
  },
  updateTransmissionAct: ({
    transmissionActId,
    data,
  }: UpdateTransmissionAct) => {
    return api({
      url: Endpoints.melpAdmin.transmissionActs.byId.root.replace(
        ':transmissionActId',
        transmissionActId,
      ),
      data: { ...data },
      method: 'patch',
    });
  },
  exportXls: ({ transmissionActId }: ExportXls) => {
    return api({
      url: Endpoints.melpAdmin.transmissionActs.byId.export.xls.replace(
        ':transmissionActId',
        transmissionActId,
      ),
      ...exportXlsxConfig,
    });
  },
};
